import React from "react";
import { type DropdownWithoutOptionsProps } from "../models";
import BaseReactSelectDropdown from "./BaseReactSelectDropdown";

const GuestlistEntryTypeDropdown = (props: DropdownWithoutOptionsProps<server.dto.GuestlistEntryType, server.dto.GuestlistEntryTypes>) => {
  return <BaseReactSelectDropdown
    excludeKeys={props.excludeKeys}
    options={serverReference.guestlistEntryTypes}
    getLabel={p => p.text}
    getValue={(t) => t.value}
    value={props.value}
    onChange={props.onChange}
    onEsc={props.onEsc}
    config={props.config}
  />;
};

export default GuestlistEntryTypeDropdown;